import { render, staticRenderFns } from "./UserLabels.global.vue?vue&type=template&id=f0644c5e&lang=pug&"
import script from "./UserLabels.global.vue?vue&type=script&lang=ts&"
export * from "./UserLabels.global.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports